export default function initGlobalBackgroundArrows() {
  const rightArrowStart = 500;
  const leftArrowStart = 3400;

  const rightArrowRequirement = rightArrowStart + 2600;
  const leftArrowRequirement = leftArrowStart + 2600;

  let pageHeight;

  if (document.querySelector(".js-page-content-wrapper")) {
    pageHeight = document.querySelector(
      ".js-page-content-wrapper",
    ).scrollHeight;
  } else if (document.querySelector(".main-content-wrapper")) {
    pageHeight = document.querySelector(".main-content-wrapper").scrollHeight;
  } else {
    console.warn(
      "The main content wrapper needs to have either of the following classes for the global background arrows to appear: js-page-content-wrapper, main-content-wrapper",
    );
  }

  //   Append the right arrow only if the page is tall enough.
  if (pageHeight > rightArrowRequirement) {
    document.body.classList.add("right-arrow");
  }

  //   Append the left arrow only if the page is tall enough.
  if (pageHeight > leftArrowRequirement) {
    document.body.classList.add("left-arrow");
  }

  window.addEventListener("scroll", () => {
    // Show right arrow transition
    if (
      window.scrollY >= rightArrowStart &&
      window.scrollY <= rightArrowStart + 100
    ) {
      document.body.classList.add("right-arrow--active");
    }

    // Show left arrow transition
    if (
      window.scrollY >= leftArrowStart &&
      window.scrollY <= leftArrowStart + 100
    ) {
      document.body.classList.add("left-arrow--active");
    }
  });
}
